// @ts-nocheck
import { useEffect, useMemo } from 'react';
import { createTheme } from '@mui/material';
import { useSelector } from 'react-redux';
import cloneDeep from 'lodash/cloneDeep';
import merge from 'lodash/merge';

import darkThemeConfig from './dark';
import lightThemeConfig from './light';
import { useThemeAppearanceQuery } from '../features/configuration/themeAppearance/api/themeAppearanceQueries';
import { saveThemeInLocalStorage } from '../features/configuration/themeAppearance/hooks/useThemeAppearance';

const LIGHT_THEME = 'light';

/**
 * @description Custom hook to get the current theme based on the theme value.
 * @returns {object} - The current theme object.
 */
const useCurrentTheme = () => {
  const { isAuthenticate, themeMode } = useSelector(
    (state) => state?.users || {}
  );
  const { data: currentSavedTheme } = useThemeAppearanceQuery({
    params: { theme: themeMode },
    options: {
      enabled: isAuthenticate,
      loader: false,
    },
  });

  useEffect(() => {
    if (currentSavedTheme) {
      saveThemeInLocalStorage(currentSavedTheme);
    }
  }, [currentSavedTheme]);

  return useMemo(() => {
    const baseTheme =
      themeMode === LIGHT_THEME ? lightThemeConfig : darkThemeConfig;
    const savedTheme = currentSavedTheme?.saved_theme;

    return createTheme(
      savedTheme
        ? merge(cloneDeep(baseTheme), cloneDeep(savedTheme))
        : cloneDeep(baseTheme)
    );
  }, [currentSavedTheme?.saved_theme, themeMode]);
};

export default useCurrentTheme;
